import {
  syncTranslationWithStore,
  loadTranslations,
  setLocale,
  I18n
} from 'react-redux-i18n';

export const setupI18n = ({store, translations, language}, _syncTranslationWithStore = syncTranslationWithStore) => {
  _syncTranslationWithStore(store);

  if (_syncTranslationWithStore !== syncTranslationWithStore) {
    syncTranslationWithStore(store);
  }

  store.dispatch(loadTranslations(translations));
  store.dispatch(setLocale(language.toLowerCase()));

  I18n.setHandleMissingTranslation(handleMissingTranslation);
};

export const handleMissingTranslation = translationKey => {
  if (translationKey && translationKey.length > 0) {
    return translationKey.split('.').pop();
  }
  
  return null;
};

export const translateOrDefault = (translationKey, defaultValue) => {
  I18n.setHandleMissingTranslation(() => defaultValue);

  try {
    return I18n.t(translationKey);
  } finally {
    I18n.setHandleMissingTranslation(handleMissingTranslation);
  }
};
